/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_CtaInputs */

const et_pricing_cta = /** @type {(inputs: Pricing_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alusta kohe`)
};

const en_pricing_cta = /** @type {(inputs: Pricing_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Get started`)
};

/**
* | output |
* | --- |
* | "Get started" |
*
* @param {Pricing_CtaInputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const pricing_cta = /** @type {((inputs?: Pricing_CtaInputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_CtaInputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_pricing_cta(inputs)
	return en_pricing_cta(inputs)
});